export const ALERT_GRAPH_WINDOW_HOURS = 8;

export interface AlertGraphWindow {
  startMs: number;
  endMs: number;
}

export function buildAlertGraphWindowMs(
  centerMs: number,
  windowHours: number = ALERT_GRAPH_WINDOW_HOURS,
): AlertGraphWindow {
  const halfWindowMs = (windowHours / 2) * 60 * 60 * 1000;
  return {
    startMs: centerMs - halfWindowMs,
    endMs: centerMs + halfWindowMs,
  };
}
